<template>
	<div>
		<div id="newImage">
			<a :href="item.svg" :download="fileName" v-if="isAndroid">
				<img :src="item.svg" :alt="fileName"/>
			</a>
			<img :src="item.svg" :alt="fileName" v-else/>
		</div>
	</div>

</template>

<script>
	import NewspaperModel from '../models/newspaper.model'
  import moment from 'moment'
  import { isAndroid } from 'mobile-device-detect'


  export default {
		name: 'ExportImage',

		data () {
			return {
				isAndroid:true
			}
		},

		computed: {
			item () {
				return NewspaperModel.query().find(1)
			},
			fileName() {
          const headline = this.item.headline && this.item.headline !== '<br>' ? this.item.headline : ''
          return ((headline || moment(new Date()).format('YYYY年MM月DD日'))) + '.jpeg'
			}
		},

		mounted() {
		    this.isAndroid = isAndroid;
    }
  }
</script>

<style scoped>
	div {
		/*width: 1495px !important;*/
		/*height: 2099px !important;*/
	}

	img {
		width: 100%;
		height: auto;
	}

	h2 {
		font-size: 2rem;
		text-align: center;
		margin-bottom: 20px;
		font-family: "Noto Sans JP", sans-serif;
	}
</style>